import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Button from './Button';


interface CardInterface
{
  src:string;
  title:string;
  textBtn:string;
  redirectTo:string;
}

const Card : React.FC<CardInterface> = (props) => {
  const navigate = useNavigate();

  function btnHandler(event: React.MouseEvent<HTMLButtonElement>)
  {
    navigate(props.redirectTo);
  }

  return (
    <div className="flex justify-center">
      <div className="flex flex-col rounded-lg shadow-lg bg-white max-w-sm">
        <Link to={props.redirectTo}>
          <img className="rounded-t-lg max-h-[18rem] w-full" src={props.src} alt="" />
        </Link>
        <div className="flex flex-col h-full p-6">
          <h5 className="text-gray-900 text-xl font-medium mb-2">{props.title}</h5>
          <div className="text-gray-700 text-base mb-4">{props.children}</div>
          <Button className="mt-auto" onClick={btnHandler}>{props.textBtn}</Button>
        </div>
      </div>
    </div>
  );
};

export default Card;
